import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';

const PrivacyPolicyModal = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-slate-400 hover:text-white cursor-pointer">
          Πολιτική Απορρήτου (GDPR)
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center greek-font">
            🔒 Πολιτική Απορρήτου (GDPR)
          </DialogTitle>
          <p className="text-center text-gray-600">Τελευταία ενημέρωση: 03/03/2026</p>
        </DialogHeader>
        
        <div className="space-y-6 text-sm">
          <div className="bg-orange-50 border border-orange-200 p-4 rounded-lg">
            <h3 className="text-lg font-bold text-orange-800 mb-2">⚠️ ΣΗΜΑΝΤΙΚΗ ΣΗΜΕΙΩΣΗ</h3>
            <p className="text-orange-700">Αυτή η εφαρμογή παρέχει ΜΟΝΟ ενημερωτικές πληροφορίες και ΔΕΝ αποτελεί νομική συμβουλή. Για επίσημη νομική συμβουλευτική, ΠΑΝΤΑ συμβουλευτείτε επαγγελματία δικηγόρο.</p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">1. Υπεύθυνος Επεξεργασίας</h3>
            <div className="bg-gray-50 border border-gray-200 p-4 rounded">
              <p className="font-bold">PROTOS AI Agency IKE</p>
              <p className="text-xs text-gray-500 mb-1">Ανάπτυξη & Ιδιοκτησία της πλατφόρμας ΝΟΜΟΚΡΑΤΙΑ</p>
              <p>Διεύθυνση: Αρχαιολογικού Μουσείου 17</p>
              <p>Ταχυδρομικός Κώδικας: 54640 Θεσσαλονίκη</p>
              <p>ΑΦΜ: 802208607 | ΓΕΜΗ: 172146906000</p>
              <p>Email: info@nomokratia.ai</p>
              <p>Website: www.nomokratia.ai</p>
              <p>Υπεύθυνος Προστασίας Δεδομένων: info@nomokratia.ai</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">2. Συλλογή Προσωπικών Δεδομένων</h3>
            <p className="mb-3">Δεδομένα που συλλέγουμε:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Στοιχεία Λογαριασμού (ονοματεπώνυμο, email, τηλέφωνο, ΑΦΜ, διεύθυνση)</li>
              <li>Νομικές Ερωτήσεις</li>
              <li>Απαντήσεις AI</li>
              <li>Στοιχεία Πληρωμής μέσω Stripe</li>
              <li>Τεχνικά Δεδομένα (IP, browser, συσκευή)</li>
              <li>Cookies (session, προτιμήσεις)</li>
            </ul>
            <div className="mt-4">
              <h4 className="font-semibold mb-2">CRM Δεδομένα Δικηγόρων:</h4>
              <ul className="list-disc list-inside space-y-1">
                <li>Στοιχεία Πελατών/Εντολέων (ονοματεπώνυμο, ΑΦΜ, ΑΜΚΑ, στοιχεία επικοινωνίας)</li>
                <li>Υποθέσεις & Δικόγραφα</li>
                <li>Προθεσμίες & Χρονοχρέωση</li>
                <li>Τιμολόγια & Οικονομικά Στοιχεία</li>
                <li>Ανεβασμένα Έγγραφα & Αρχεία</li>
              </ul>
            </div>
            <div className="bg-blue-50 border border-blue-200 p-4 rounded mt-4">
              <h4 className="font-bold text-blue-800 mb-2">⚠️ ΑΚΡΙΒΕΙΑ AI ΑΠΟΤΕΛΕΣΜΑΤΩΝ</h4>
              <p className="text-blue-700">Η πλατφόρμα αξιοποιεί τεχνητή νοημοσύνη (AI) για νομική αναζήτηση και ανάλυση σε 3.5M+ έγγραφα. Τα αποτελέσματα έχουν ακρίβεια άνω του 90%, αλλά <strong>ΔΕΝ εγγυώνται πλήρη ακρίβεια ή επικαιρότητα</strong>.</p>
              <p className="text-blue-700 mt-2"><strong>Ο δικηγόρος φέρει πάντα την ευθύνη</strong> να επαληθεύει τα αποτελέσματα, να ελέγχει την ισχύ νομοθεσίας και νομολογίας, και να μην στηρίζεται αποκλειστικά στις AI αναλύσεις για τη λήψη νομικών αποφάσεων.</p>
              <p className="text-blue-700 mt-2">Η PROTOS AI Agency IKE <strong>αποκλείει κάθε ευθύνη</strong> για ζημίες που τυχόν προκύψουν από τη χρήση των AI αποτελεσμάτων χωρίς ανεξάρτητη επαλήθευση από τον δικηγόρο.</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">3. Σκοπός Επεξεργασίας</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Παροχή Υπηρεσιών: AI νομική αναζήτηση και CRM (ενημερωτικές μόνο)</li>
              <li>Διαχείριση Λογαριασμού</li>
              <li>Χρεώσεις μέσω Stripe</li>
              <li>Βελτίωση Υπηρεσιών</li>
              <li>Νομικές Υποχρεώσεις</li>
              <li>Ασφάλεια</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">4. Νομική Βάση Επεξεργασίας (GDPR)</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Άρθρο 6(1)(a) – Συγκατάθεση</li>
              <li>Άρθρο 6(1)(b) – Εκτέλεση Σύμβασης</li>
              <li>Άρθρο 6(1)(c) – Νομική Υποχρέωση</li>
              <li>Άρθρο 6(1)(f) – Έννομο Συμφέρον</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">5. Κοινοποίηση σε Τρίτους</h3>
            <ul className="list-disc list-inside mb-3 space-y-1">
              <li>Anthropic (ανωνυμοποιημένα δεδομένα για AI επεξεργασία)</li>
              <li>Stripe (πληρωμές)</li>
              <li>MongoDB (βάση δεδομένων, τοπικός server στη Γερμανία/EU)</li>
              <li>Hetzner (φιλοξενία, EU servers)</li>
              <li>Αρχές (μόνο με δικαστική απόφαση)</li>
            </ul>
            <div className="bg-red-50 border border-red-200 p-3 rounded">
              <p className="text-red-700 font-bold">⚠️ ΔΕΝ πουλάμε, ΔΕΝ νοικιάζουμε, ΔΕΝ μοιραζόμαστε δεδομένα για marketing.</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">6. Διατήρηση Δεδομένων</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <ul className="list-disc list-inside space-y-1">
                <li>Στοιχεία Λογαριασμού: 2 χρόνια</li>
                <li>Νομικές Ερωτήσεις: 3 χρόνια</li>
                <li>Πληρωμές: 7 χρόνια</li>
              </ul>
              <ul className="list-disc list-inside space-y-1">
                <li>Logs: 6 μήνες</li>
                <li>Cookies: 14 ημέρες</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">7. Τα Δικαιώματά σας (GDPR)</h3>
            <p className="mb-3">Πρόσβαση, Διόρθωση, Διαγραφή, Περιορισμός, Φορητότητα, Αντίρρηση, Ανάκληση Συγκατάθεσης.</p>
            <div className="bg-slate-50 border border-slate-200 p-3 rounded">
              <p className="text-slate-900">📧 <strong>info@nomokratia.ai</strong> — απάντηση σε 30 ημέρες.</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">8. Ασφάλεια Δεδομένων</h3>
            <p>TLS/SSL, AES-256, Bcrypt, monitoring, backups, EU servers.</p>
            <div className="mt-3">
              <h4 className="font-semibold mb-2">Απομόνωση Δεδομένων CRM:</h4>
              <ul className="list-disc list-inside space-y-1 text-sm">
                <li>Κάθε δικηγόρος βλέπει <strong>αποκλειστικά</strong> τα δικά του δεδομένα</li>
                <li>Πλήρης απομόνωση πελατών, υποθέσεων και εγγράφων ανά χρήστη</li>
                <li>Ο διαχειριστής της πλατφόρμας <strong>δεν έχει πρόσβαση</strong> στο περιεχόμενο των υποθέσεων</li>
                <li>Διαγραφή λογαριασμού = οριστική διαγραφή <strong>όλων</strong> των δεδομένων</li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">9. Cookies και Tracking</h3>
            <p className="mb-2">Μόνο session και Stripe cookies.</p>
            <div className="bg-green-50 border border-green-200 p-3 rounded">
              <p className="text-green-700">❌ <strong>Όχι tracking / analytics / ads cookies.</strong></p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">10. Διεθνείς Μεταφορές</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Hetzner (EU servers, Germany)</li>
              <li>Anthropic (ΗΠΑ) με SCCs</li>
              <li>Stripe (PCI DSS certified)</li>
              <li>MongoDB (τοπικός server, Hetzner Germany/EU)</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">11. Καταγγελίες</h3>
            <div className="bg-gray-50 border border-gray-200 p-4 rounded">
              <p className="font-bold">Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα</p>
              <p>Κηφισίας 1-3, 11523 Αθήνα</p>
              <p>☎️ +30 210 6475600</p>
              <p>📧 contact@dpa.gr</p>
              <p>🌐 www.dpa.gr</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">12. Ανακοίνωση – Προστασία Περιεχομένου</h3>
            <p className="mb-3">Τελευταία ενημέρωση: 19 Φεβρουαρίου 2026</p>
            
            <div className="bg-slate-50 border border-slate-200 p-4 rounded mb-4">
              <h4 className="font-bold text-slate-900 mb-2">📢 ΣΗΜΑΝΤΙΚΗ ΕΝΗΜΕΡΩΣΗ</h4>
              <p className="text-slate-900">Περιορισμός δωρεάν περιεχομένου για προστασία από AI scraping</p>
              <p className="text-slate-900 mt-2">Η πλατφόρμα AI ΝΟΜΟΚΡΑΤΙΑ περιορίζει το δωρεάν περιεχόμενο για μη συνδρομητικούς χρήστες.</p>
            </div>

            <h4 className="font-semibold mb-2">Λόγοι:</h4>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Προστασία Premium Συνδρομητών</li>
              <li>Αποτροπή AI Scraping σε 150.000+ νομοθετήματα & αποφάσεις</li>
              <li>Προστασία Δεδομένων</li>
            </ul>

            <div className="bg-yellow-50 border border-yellow-200 p-3 rounded mb-4">
              <p className="text-yellow-800">Η πλατφόρμα ΝΟΜΟΚΡΑΤΙΑ ΔΕΝ επιτρέπει scraping χωρίς άδεια.</p>
              <p className="text-yellow-800 mt-2">📄 Εταιρική άδεια παροχής δεδομένων δίνεται ΜΟΝΟ κατόπιν έγγραφης συμφωνίας.</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">🚀 Νέες Βελτιώσεις Υπηρεσιών</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>AI-Powered Legal Consultation (Anthropic Claude)</li>
              <li>Premium Νομολογία (ελληνικές & ευρωπαϊκές αποφάσεις)</li>
              <li>Advanced Search με γλωσσική ανάλυση</li>
              <li>Email Registration με πλήρη στοιχεία δικηγόρου</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 greek-font">💰 Νέα Πακέτα & Τιμές</h3>
            
            <div className="grid md:grid-cols-3 gap-4 mb-4">
              <div className="border border-slate-200 p-3 rounded">
                <h4 className="font-bold text-slate-900 mb-2">🆓 Δοκιμαστικό – Δωρεάν</h4>
                <p className="text-sm mb-2">14 ημέρες πλήρης πρόσβαση</p>
                <ul className="text-xs list-disc list-inside space-y-1">
                  <li>Πλήρες CRM</li>
                  <li>AI Αναζήτηση Νομολογίας</li>
                  <li>10 AI ερωτήματα/ημέρα</li>
                  <li>Χωρίς πιστωτική κάρτα</li>
                </ul>
              </div>

              <div className="border border-green-200 p-3 rounded">
                <h4 className="font-bold text-green-700 mb-2">💼 Επαγγελματικό – 199€/μήνα</h4>
                <p className="text-sm mb-2">Για ατομικά δικηγορικά γραφεία</p>
                <ul className="text-xs list-disc list-inside space-y-1">
                  <li>Απεριόριστα AI ερωτήματα</li>
                  <li>AADE / myDATA ενσωμάτωση</li>
                  <li>Τιμολόγηση</li>
                  <li>Conflict Check</li>
                  <li>Τηλεφωνική υποστήριξη</li>
                </ul>
              </div>

              <div className="border border-purple-200 p-3 rounded">
                <h4 className="font-bold text-purple-700 mb-2">🏢 Δικηγορικό Γραφείο – Κατόπιν επικοινωνίας</h4>
                <p className="text-sm mb-2">Για δικηγορικές εταιρείες</p>
                <ul className="text-xs list-disc list-inside space-y-1">
                  <li>Έως 10 χρήστες</li>
                  <li>API πρόσβαση</li>
                  <li>Custom Integrations</li>
                  <li>Προτεραιότητα υποστήριξης</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-red-50 border border-red-200 p-4 rounded">
            <h3 className="text-lg font-bold text-red-800 mb-2">ΣΗΜΑΝΤΙΚΟΣ ΑΠΟΚΛΕΙΣΜΟΣ ΕΥΘΥΝΩΝ</h3>
            <p className="text-red-700">Η PROTOS AI Agency IKE ΔΕΝ παρέχει νομικές συμβουλές. Όλες οι απαντήσεις είναι ενημερωτικές.</p>
            <p className="text-red-700 mt-2 font-bold">Για επίσημη νομική συμβουλευτική, ΠΑΝΤΑ συμβουλευτείτε επαγγελματία δικηγόρο.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};


export default PrivacyPolicyModal;
